export const MACRO_MEDIA_BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/MACRO`;
